import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DarkStyleDirective } from 'src/app/shared/directives/darkStyle/dark-style.directive';
import { ApplicationPipesModule } from 'src/app/shared/pipes/application-pipes.module';
import { ContractDialogModule } from './contracts/components/contract-dialog/contracts-dialog.module';
import { CustomerAcessModule } from './customer-acess/customer-acess.module';
import { DownloadsModule } from './downloads/downloads.module';
import { EventsModule } from './events-forms/events.module';
import { FaqModule } from './faq-events/faq.module';
import { MerchantsModule } from './merchants/merchants.module';
import { PartnersModule } from './partners/partners.module';
import { PaymentMethodsModule } from './payment-methods/payment-methods.module';
import { PlanPermissionsModule } from './plan-permissions/plan-permissions.module';
import { PlansModule } from './plans/plans.module';
import { FinancialSettingsModule } from './shared/financial-settings/financial-settings.module';
import { GlobalConfigModule } from './shared/global-config/global-config.module';
import { SystemActionCategoriesModule } from './system-action-categories/system-action-categories.module';
import { SystemActionParamsModule } from './system-action-params/system-action-params.module';
import { SystemActionsModule } from './system-actions/system-actions.module';
import { SystemModulesModule } from './system-modules/system-modules.module';
import { SystemsModule } from './systems/systems.module';
import { UserGroupPermissionsModule } from './user-group-permissions/user-group-permissions.module';
import { UserGroupsModule } from './user-groups/user-groups.module';
import { UserPermissionsModule } from './user-permissions/user-permissions.module';
import { UserModule } from './users/crud.module';

@NgModule({
  declarations: [
    DarkStyleDirective,
  ],
  imports: [
    CommonModule,
    ApplicationPipesModule,
    PlansModule,
    UserModule,
    SystemActionsModule,
    SystemActionCategoriesModule,
    SystemActionParamsModule,
    UserGroupsModule,
    UserGroupPermissionsModule,
    PlanPermissionsModule,
    UserPermissionsModule,
    SystemsModule,
    SystemModulesModule,
    DownloadsModule,
    FaqModule,
    PaymentMethodsModule,
    PartnersModule,
    FinancialSettingsModule,
    CustomerAcessModule,
    GlobalConfigModule,
    EventsModule,
    ContractDialogModule,
    MerchantsModule
  ],
  exports: [
    DarkStyleDirective,
    PartnersModule
  ]
})
export class RegistrationModule { }
